export default __webpack_public_path__ + "static/media/info-tooltip-notaconvertible.3cb30f3a.svg";